import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FileInfo } from '@progress/kendo-angular-upload';
import { RgFormGroup } from '../../models/menu';

@Component({
  selector: 'app-prompt',
  templateUrl: './prompt.component.html',
  styleUrls: ['./prompt.component.scss'],
})
export class PromptComponent implements OnInit {
  form = new UntypedFormGroup({});
  @Input() set formGroup(value: any) {
    this.form = value;
  }

  @Output() save = new EventEmitter<RgFormGroup>();
  @Output() delete = new EventEmitter<RgFormGroup>();

  ngOnInit(): void {}

  onSave() {
    this.save.emit(this.form as any);
  }

  onDelete() {
    this.delete.emit(this.form as any);
  }

  public sayMp3Selected(e: FileInfo[]): void {
  }

  public sayByeMp3Selected(e: FileInfo[]): void {
  }
}
